import ButtonWrapper from '../../../components/custom-controls/button-wrapper/button-wrapper';
import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';
import { Box, Typography } from '@mui/material';

export function getTourCompletedStep({
	defaultStyles,
	selector,
	completionId,
}: ComponentTourProps & { selector: string; completionId?: string }): AdvancedTourStep {
	return {
		id: completionId ?? `${selector}-completed`,
		selector: `[data-tour="${selector}"]`,
		styles: defaultStyles,
		content: ({ setIsOpen }) => (
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
				<Typography>Tour completed. Click below to close the tutorial or click the 'x'.</Typography>
				<ButtonWrapper
					label="Complete"
					variant="light"
					id="finish-tour"
					onClick={() => setIsOpen(false)}
				/>
			</Box>
		),
	};
}
